(function () {
  const checkVideoInterval = setInterval(() => {
    const videoMediaElement = document.querySelector(
      "dynamic-grid > div > div > figure > video-media"
    );
    if (videoMediaElement) {
      clearInterval(checkVideoInterval);

      const videoElement = videoMediaElement.querySelector("video");
      if (videoElement) {
        videoElement.addEventListener("play", function () {
          window.posthog.capture("product_page_hero_video_played");
        });
      }
    }
  }, 50);
})();
